export default __webpack_public_path__ + "static/media/Mike Sernandez.e4b57127.jpg";